// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as GdChartBridgeTs from "../../../js/charts/gd-chart-bridge.ts";

function createGdChartSession(prim0, prim1) {
  return GdChartBridgeTs.createGdChartSession(prim0, prim1);
}

function mounted() {
  var self = this ;
  var s = GdChartBridgeTs.createGdChartSession(self.el, (function ($$event, payload) {
          self.pushEvent($$event, payload);
        }));
  self._gdChartSession = Caml_option.some(s);
  s.sync();
}

function updated() {
  var self = this ;
  var s = self._gdChartSession;
  if (s !== undefined) {
    Caml_option.valFromOption(s).sync();
    return ;
  }
  
}

function destroyed() {
  var self = this ;
  var s = self._gdChartSession;
  if (s !== undefined) {
    Caml_option.valFromOption(s).destroy();
  }
  self._gdChartSession = undefined;
}

var GdChart = {
  mounted: mounted,
  updated: updated,
  destroyed: destroyed
};

export {
  createGdChartSession ,
  mounted ,
  updated ,
  destroyed ,
  GdChart ,
}
/* mounted Not a pure module */
